import React from 'react';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { Avatar } from '../components/Avatar';
import { Button } from '../components/Button';
import { UserIcon, CreditCardIcon, BellIcon, HelpCircleIcon, LogOutIcon, ChevronRightIcon, SettingsIcon } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
export const Profile = () => {
  const {
    logout
  } = useAuth();
  // Mock user data
  const user = {
    name: 'Uwe Janssen',
    email: 'uwe.janssen@gmx.net',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    memberSince: 'June 2023'
  };
  const menuItems = [{
    icon: <UserIcon className="h-5 w-5" data-id="element-431" />,
    label: 'Personal Information',
    action: () => console.log('Personal Information')
  }, {
    icon: <CreditCardIcon className="h-5 w-5" data-id="element-432" />,
    label: 'Payment Methods',
    action: () => console.log('Payment Methods')
  }, {
    icon: <BellIcon className="h-5 w-5" data-id="element-433" />,
    label: 'Notifications',
    action: () => console.log('Notifications')
  }, {
    icon: <SettingsIcon className="h-5 w-5" data-id="element-434" />,
    label: 'Settings',
    action: () => console.log('Settings')
  }, {
    icon: <HelpCircleIcon className="h-5 w-5" data-id="element-435" />,
    label: 'Help & Support',
    action: () => console.log('Help & Support')
  }];
  return <div className="bg-white min-h-screen pb-16" data-id="element-436">
      <Header title="Profile" data-id="element-437" />
      <div className="p-4" data-id="element-438">
        <div className="border border-dashed border-gray-300 rounded-lg p-4 mb-6 flex items-center" data-id="element-439">
          <Avatar name={user.name} alt={user.name} src={user.avatar} size="lg" data-id="element-440" />
          <div className="ml-4" data-id="element-441">
            <h2 className="text-lg font-medium text-gray-800" data-id="element-442">{user.name}</h2>
            <p className="text-sm text-gray-600" data-id="element-443">{user.email}</p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-444">
              Member since {user.memberSince}
            </p>
          </div>
        </div>
        <div className="border border-gray-300 rounded-lg mb-6 overflow-hidden" data-id="element-445">
          {menuItems.map((item, index) => <div key={index} className={`p-4 flex items-center justify-between cursor-pointer hover:bg-gray-50 ${index < menuItems.length - 1 ? 'border-b border-gray-200' : ''}`} onClick={item.action} data-id="element-446">
              <div className="flex items-center" data-id="element-447">
                <div className="text-gray-600 mr-3" data-id="element-448">{item.icon}</div>
                <span className="text-gray-800" data-id="element-449">{item.label}</span>
              </div>
              <ChevronRightIcon className="h-5 w-5 text-gray-400" data-id="element-450" />
            </div>)}
        </div>
        <Button variant="secondary" className="w-full" leftIcon={<LogOutIcon className="h-5 w-5" data-id="element-452" />} onClick={logout} data-id="element-451">
          Log Out
        </Button>
      </div>
      <Navigation data-id="element-453" />
    </div>;
};